export default "__VITE_ASSET__xELhR3ZK__"